/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_Email_MissingInputs */

const fr_account_audit_email_missing = /** @type {(inputs: Account_Audit_Email_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email non confirmé`)
};

/**

* @param {Account_Audit_Email_MissingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_email_missing = /** @type {((inputs?: Account_Audit_Email_MissingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Email_MissingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_email_missing(inputs)
});